import type { Filter } from '@/typings/Filter'
import type { PeriodsDiff } from '@/typings/Shipments/PeriodsDiff'
import type { DataCollection } from '@/typings/DataCollection'
import type { MarkerItem } from '@/typings/Shipments/MarkerItem'
import type { CustomerData } from '@/typings/Customers/CustomerData'
import type { Periods } from '@/typings/Periods'
import { defineStore } from 'pinia'
import { ApiRequest } from '@/requests/ApiRequest'

const Shipments = defineStore('shipments', {
  getters: {
    api: () => new ApiRequest(),
  },
  actions: {
    async getStatsData(filters: Filter) {
      return await this.api.get<DataCollection<PeriodsDiff>>('/statistics/diff/shipmentsTotal', filters)
    },
    async getStatsTodayData(filters: Filter) {
      return await this.api.get<DataCollection<PeriodsDiff>>('/statistics/diff/shipmentsTotalToday', filters)
    },

    async getCitiesData(filters: Filter) {
      return await this.api.get<DataCollection<MarkerItem>>('/statistics/city/shipmentsByCity', filters)
    },

    async getTotalSales(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/shipmentsPeriod', filters)
    },

    async getShipmentsPeriodCustomer(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/shipmentsPeriodCustomer', filters)
    },

    async getShipmentsVolume(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/shipmentsVolume', filters)
    },

    async getShipmentsCreated(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/shipmentsCreated', filters)
    },

    async getShipmentsSent(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/shipmentsFirstScan', filters)
    },

    async getShipmentsForwardToServicePoint(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/forwardedToServicePoints', filters)
    },

    async getReturnedShipments(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/returnedShipments', filters)
    },

    async getAverageShippingPrice(filters: Filter) {
      return await this.api.get<Periods>('/statistics/period/averageShippingPrice', filters)
    },

    async getDeliveryTime(filters: Filter) {
      filters['distributionChannel'] = filters['distributionChannel'] || 'package'
      return await this.api.get<DataCollection<PeriodsDiff>>('/statistics/diff/shipmentsAverageDeliveryTime', filters)
    },

    async getUsage(filters: Filter) {
      filters['distributionChannel'] = filters['distributionChannel'] || 'package'
      return await this.api.get<DataCollection<PeriodsDiff>>('/statistics/diff/shipmentsUsage', filters)
    },

    async getAveragePackagePrice(filters: Filter) {
      filters['distributionChannel'] = filters['distributionChannel'] || 'package'
      filters['serviceLevel'] = filters['serviceLevel'] || 'priority'
      return await this.api.get<DataCollection<PeriodsDiff>>('/statistics/diff/averagePackagePrice', filters)
    },

    async getCustomers() {
      return await this.api.get<DataCollection<CustomerData>>('/statistics/users')
    },
  },
})

export default Shipments
